angular.module('impactx').service('$redirect', ['$route', '$location', '$routeParams', RedirectService]);

function RedirectService($route, $location, $routeParams) {
    var self = this;
    this.lastParameters = {};
    /**
     * Function to redirect to a given location, reloads page if already on the right page
     * @param next The page that is called next
     * @param redirect Page that should be redirected to
     * @param parameters the parameters to save for the route. Optional.
     */
    function redirectTo(next, redirect, parameters) {
        if(redirect && redirect.charAt(0) !== "/") {
            redirect = "/" + redirect;
        }
        // Split path and query string so $location.path() receives only the path part.
        // $location.path() encodes '?' as '%3F', merging query params into the path segment.
        var queryStart = redirect ? redirect.indexOf('?') : -1;
        var redirectPath = queryStart >= 0 ? redirect.substring(0, queryStart) : redirect;
        var queryString = queryStart >= 0 ? redirect.substring(queryStart + 1) : null;

        if(impactX.isDefined($route, "current.$$route.regexp") && $route.current.$$route.regexp.test(redirectPath)) {
            //compare the original path with the new route.
            var originalPathDefinitions = $route.current.$$route.originalPath.split("/");
            var newRouteDefinitions = redirectPath.split("/");

            var routeParams = [];
            //extract the "real" params. (Something with a starting ':' in the route definition.
            for (var j = 0; j < newRouteDefinitions.length; j++) {
                if (originalPathDefinitions[j].indexOf(":") == 0) {
                    routeParams.push(newRouteDefinitions[j]);
                }
            }

            // check length of params first, if not equal don't bother checking content.
            // this also prevents a false-positive if $routeParams has no entries but routeParams has.
            var paramsLength = 0;
            for (var k in $routeParams) {
                paramsLength++;
            }
            var routeParamsEqual = paramsLength === routeParams.length;
            if(routeParamsEqual){
                var i = 0;
                for (var key in $routeParams) {
                    //Compare new params with old params. The order should be the same.
                    if ($routeParams[key] != routeParams[i])
                    {
                        routeParamsEqual = false;
                        break;
                    }
                    i++;
                }
            }
            if (routeParamsEqual) {
                $route.reload();
            }
            else {
                $location.path(redirectPath);
            }
        }
        else {
            // not going to #login, we should redirect now
            $location.path(redirectPath);
        }
        if (queryString !== null) {
            var searchParams = {};
            if (queryString) {
                queryString.split('&').forEach(function(part) {
                    var eqIdx = part.indexOf('=');
                    if (eqIdx > 0) {
                        searchParams[decodeURIComponent(part.substring(0, eqIdx))] = decodeURIComponent(part.substring(eqIdx + 1));
                    }
                });
            }
            $location.search(searchParams);
        } else {
            $location.search({});
        }
        self.lastParameters = parameters;
        if (parameters && redirect) {
            try {
                sessionStorage.setItem('ix_route_params_' + redirect, JSON.stringify(parameters));
            } catch (e) { /* ignore */ }
        }
    }

    function reload() {
        $route.reload();
    }

    /**
     * Returns the saved parameters and deletes it (important to prevent strange effects).
     * @returns the saved parameters.
     */
    function getLastParameters() {
        var toReturn = self.lastParameters;
        if (!toReturn || Object.keys(toReturn).length === 0) {
            try {
                var currentPath = $location.path();
                var stored = sessionStorage.getItem('ix_route_params_' + currentPath);
                if (stored) {
                    toReturn = JSON.parse(stored);
                }
            } catch (e) { /* ignore */ }
        }
        self.lastParameters = {};
        return toReturn;
    }

    return {
        redirectTo: redirectTo,
        reload: reload,
        getLastParameters: getLastParameters
    };
}